import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import RoundButton from '../../components/RoundButton';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PlayBtn from '../../assets/play_btn.svg';
import Delete from '../../assets/Delete.png';
import search from '../../assets/ic_search.png';
import './EditPlaylistSecondery.scss';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { useLocation } from 'react-router-dom';
import { _showAlert, formatDateToDisplay, _isAuthenticated } from '../../utils';
import { LoaderSpinner } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from '../../components/Modal';
import UploadImageSvg from './UpalodImageSvg';
import { useRef } from 'react';
import ApiCaller from '../../redux/ApiCaller';
import { CircularProgress } from '@material-ui/core';
import Dropdown from '../../components/Dropdown';
import { royalty } from '../../generalConstant';
import Popup from '../../components/Popup';
import plusIcon from '../../assets/icons8-plus.svg';
import EditPlaylistAndServer from '../EditPlaylistAndServer/index';
import WarningIcon from '../../components/Svgs/WarningIcon.svg.js';
import LazyImage from '../../components/LazyImage/index.jsx';
import SortIndicator from '../../components/SortIndicator';
import PlaylistCustomerDialog from '../../components/PlaylistManagement/PlaylistCustomerDialog';
import PlaylistCopySongsDialog from '../../components/PlaylistManagement/PlaylistCopySongsDialog';
import { buildPlaylistSavePayload, playlistTypeForSave } from '../../utils/safeEditPayloads';
import useRangeSelection, { updateSelectedIds } from '../../utils/useRangeSelection';
import RangeSelectionButton from '../../components/RangeSelectionButton';
import PlaylistConflictDialog from '../../components/PlaylistManagement/PlaylistConflictDialog';
import { fetcher } from '../../utils/axios';
import usePlaylistConflictRecovery from '../../utils/usePlaylistConflictRecovery';

/* 
Table Data and Use Style
*/
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    borderRadius: 30,
  },
});

const SortableItem = SortableElement(
  ({
    row,
    handleRemoveSong,
    onPlaySong,
    selected,
    onSelectSong,
    indexToDisplay,
  }) => {
    return (
      <>
        <TableRow>
          <TableCell>
            <Checkbox
              checked={selected}
              onChange={(event) => onSelectSong(row.id, event.target.checked, !!event.nativeEvent?.shiftKey)}
              inputProps={{ 'aria-label': `Select ${row.name || row.fileName || 'song'}` }}
            />
          </TableCell>
          <TableCell className="table-index-cell">{`#${indexToDisplay}`}</TableCell>
          <TableCell>{formatDateToDisplay(row.createdAt)}</TableCell>
          <TableCell>{row.name || row.fileName || 'N/A'}</TableCell>
          <TableCell>{row.artist || 'N/A'}</TableCell>
          <TableCell>
            <div style={{ height: '100%', width: '50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <img
                src={PlayBtn}
                alt="play"
                style={{ cursor: 'pointer' }}
                onClick={() => onPlaySong(row)}
              />
              <img
                alt="delete"
                style={{ height: '21px', width: '21px', objectFit: 'contain', cursor: 'pointer' }}
                src={Delete}
                onClick={() => handleRemoveSong(row)}
              />
            </div>
          </TableCell>
        </TableRow>
      </>
    );
  }
);

const SortableList = SortableContainer(
  ({
    items,
    isChangeOrder,
    handleRemoveSong,
    onPlaySong,
    selectedSongIds,
    onSelectSong,
  }) => {
    return (
      <TableBody>
        {items.map((row, index) => (
          <SortableItem
            onPlaySong={onPlaySong}
            selected={selectedSongIds.includes(row.id)}
            onSelectSong={onSelectSong}
            handleRemoveSong={handleRemoveSong}
            disabled={isChangeOrder}
            key={`item-${index}`}
            index={index}
            indexToDisplay={index + 1}
            row={row}
          />
        ))}
      </TableBody>
    );
  }
);

function EditPlaylistSecondery(props) {
  const routeLocation = useLocation();

  // * state used when page is opened as popup
  const isPageOpenedAsPopup = props.isPageOpenedAsPopup;
  const selectedPlaylistForPopup = props.selectedPlaylistForPopup;
  const onSavePlaylistFromPopup = props.onSavePlaylist;
  const isPlaylistRoyaltyForPopup = props.isPlaylistRoyalty;

  // const onSavePlaylist = props.onSavePlaylist;

  /**
   * getting state from redux store
   */
  const { addPlaylistTagStatus, deletePlaylistTagStatus } = useSelector((state) => ({
    addPlaylistTagStatus: state.addPlaylistTag.status,
    deletePlaylistTagStatus: state.deletePlaylistTag.status,
    // deletePlaylist: state.deletePlaylist.result,
    // newPlaylistRequestData: state.newPlaylist.result,
    // allTagList: state.tagList.result,
  }));

  // Add deleteSongs selector
  const deleteSongs = useSelector((state) => state.deleteSongs);
  //
  const classes = useStyles();
  const [selectedPlaylist, setPlaylist] = useState({});
  const [playlistSongs, setPlaylistSongs] = useState([]);
  const [isChangeOrder, setChangeOrder] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [isFocusOnName, setFocusOnName] = useState(false);
  const [name, setName] = useState('');
  const updatePlaylist = useSelector((state) => state.updatePlaylist.result);
  const songURL = useSelector((state) => state.getSongURL.result);
  const [open, setOpen] = React.useState(false);
  const [openPermanentDelete, setOpenPermanentDelete] = React.useState(false);
  const [selectedSong, setSelectedSong] = useState(null);
  //
  const tagList = useSelector((state) => state.tagList.result);

  const [isAddTagPopUpOpen, setIsAddTagPopUpOpen] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);

  const [removeApiTagsIds, setRemoveApiTagsIds] = useState([]);

  const [isEditPopUpOpen, setIsEditPopUpOpen] = useState(false);
  const [isDraggableView, setIsDraggableView] = useState(false);
  const [imageUploadedFromPc, setImageUpaloadedFromPc] = useState('');
  const [image, setImage] = useState(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isAddSongsPopupOpen, setIsAddSongsPopupOpen] = useState(false);
  const [showCustomers, setShowCustomers] = useState(false);
  const [showCopySongs, setShowCopySongs] = useState(false);
  const [copySelectedOnly, setCopySelectedOnly] = useState(false);
  const [selectedSongIds, setSelectedSongIds] = useState([]);
  const [bulkRemoveOpen, setBulkRemoveOpen] = useState(false);
  const [conflict, setConflict] = useState(null);
  const [conflictOpen, setConflictOpen] = useState(false);

  // Navbar player state
  const [navbarCurrentSong, setNavbarCurrentSong] = useState(null);

  const imageInputRef = useRef(null);
  const [playlistRefreshCount, setPlaylistRefreshCount] = useState(0);
  const requestedPlaylistId = (isPageOpenedAsPopup ? selectedPlaylistForPopup : routeLocation?.state?.selectedPlayList)?.id;
  const hydratedPlaylistId = useRef(null);
  const tagsSubmitted = useRef(false);
  const conflictRequested = useRef(false);
  const { choose: chooseRange, toggleRangeMode, resetRange, isRangeMode } = useRangeSelection();

  const refreshConflict = async (draft) => {
    setConflict({ draft, latest: null, loading: true });
    setConflictOpen(true);
    try {
      const playlists = await fetcher('/playlists/');
      const latest = playlists.find((item) => item.id === selectedPlaylist.id);
      if (!latest) throw new Error('Playlist not found');
      setConflict({ draft, latest, loading: false });
    } catch (error) {
      setConflict({ draft, latest: null, loading: false });
    }
  };

  const reloadLatest = (recoveredPlaylist) => {
    const latest = recoveredPlaylist?.id ? recoveredPlaylist : conflict?.latest;
    if (!latest) return;
    setPlaylist(latest);
    setPlaylistSongs(latest.songs);
    setName(latest.name);
    setIsRoyalty(latest.type === 3 ? royalty[0] : royalty[1]);
    setSelectedSongIds([]);
    resetRange('playlist-songs');
    setSelectedTags([]);
    setRemoveApiTagsIds([]);

    conflictRequested.current = false;
    setConflict(null);
    setConflictOpen(false);
  };

  // Track if delete was initiated from this component
  const [isDeleteInitiatedHere, setIsDeleteInitiatedHere] = useState(false);

  const dispatch = useDispatch();

  const [isNameEditable, setIsNameEditable] = useState(false);
  const isAdmin = JSON.parse(sessionStorage.getItem('authData'))?.user?.userRole === 1;
  const onSortEnd = ({ oldIndex, newIndex }) => {
    setPlaylistSongs((current) => arrayMove(current, oldIndex, newIndex));
  };

  const urlData = props.location.pathname.split('/');
  const isRoyalties = urlData.includes('royalties') || isPlaylistRoyaltyForPopup;

  const [isRoyalty, setIsRoyalty] = useState(isRoyalties ? royalty[0] : royalty[1]);
  let isRoyaltyValue = isRoyalty.value === 'true';
  const isStandardPlaylist = selectedPlaylist.type === 3 || selectedPlaylist.type === 4;
  const playlistTypeToSave = playlistTypeForSave(selectedPlaylist.type, isRoyaltyValue);

  const recovery = usePlaylistConflictRecovery({
    playlist: selectedPlaylist,
    originalSongIds: selectedPlaylist.songs?.map((song) => song.id),
    draft: conflict ? playlistSongs : undefined,
    metadataChanged: name !== selectedPlaylist.name || playlistTypeToSave !== selectedPlaylist.type || selectedTags.length > 0 || removeApiTagsIds.length > 0,
    onRecovered: (latest) => { reloadLatest(latest); _showAlert('Songs added. Latest playlist loaded; duplicates were skipped.', 'success'); },
  });

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  //* Fetch Tags from API
  useEffect(() => {
    // Clear any previous delete state on component mount
    dispatch({ type: 'DELETE_SONGS_RESET' });

    dispatch({ type: 'TAG_LIST' });
  }, []);

  useEffect(() => {
    if (!requestedPlaylistId) return;
    let active = true;
    setLoading(true);
    fetcher('/playlists/')
      .then((playlists) => {
        if (!active) return;
        const playlist = playlists.find((item) => item.id === requestedPlaylistId);
        if (!playlist || !Array.isArray(playlist.songs)) throw new Error('Playlist not found');
        setPlaylist(playlist);
        setPlaylistSongs(playlist.songs);
        setName(playlist.name);
        setIsRoyalty(playlist.type === 3 ? royalty[0] : royalty[1]);
        const changedPlaylist = hydratedPlaylistId.current !== playlist.id;
        setSelectedSongIds((current) => changedPlaylist ? [] : current.filter((id) => playlist.songs.some((song) => song.id === id)));
        if (changedPlaylist) resetRange('playlist-songs');
        hydratedPlaylistId.current = playlist.id;

        setSelectedTags([]);
        setRemoveApiTagsIds([]);
        const currentUser = JSON.parse(sessionStorage.getItem('authData'))?.user;
        setIsNameEditable(currentUser?.id === playlist.createdBy?.id || currentUser?.userRole === 1);
      })
      .catch(() => { if (active) _showAlert('Could not load the latest playlist. Close and reopen the editor to try again.', 'error'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [requestedPlaylistId, playlistRefreshCount, resetRange]);

  useEffect(() => {
    if (updatePlaylist.id && addPlaylistTagStatus !== 'initiated' && deletePlaylistTagStatus !== 'initiated') {
      if (!tagsSubmitted.current) {
        tagsSubmitted.current = true;
        if (selectedTags.length) {
          dispatch({ type: 'ADD_PLAYLIST_TAG', payload: { playlistId: selectedPlaylist.id, tagIds: selectedTags.map((tag) => tag.id) } });
          setSearchInput('');
        }
        if (removeApiTagsIds.length) {
          dispatch({ type: 'DELETE_PLAYLIST_TAG', payload: { playlistId: selectedPlaylist.id, tagIds: removeApiTagsIds } });
        }
        if (selectedTags.length || removeApiTagsIds.length) return;
      }
      // setLoading(false);
      _showAlert('Playlist Successfully Updated', 'success');
      // props.history.push(isRoyalties ? '/royalties/edit-playlist-main' : '/non-royalties/edit-playlist-main');
      dispatch({ type: 'CLEAR_STATE', actionName: 'UPDATE_PLAYLIST' });

      // * Now we recall the API for get playlists to update the state
      if (isPageOpenedAsPopup) {
        onSavePlaylistFromPopup();
        return;
      }
      setPlaylistRefreshCount((count) => count + 1);
    }
    if (updatePlaylist.error) {
      setLoading(false);
      if (updatePlaylist.code === 409) {
        if (!conflictRequested.current) {
          conflictRequested.current = true;
          refreshConflict(playlistSongs);
        }
        dispatch({ type: 'CLEAR_STATE', actionName: 'UPDATE_PLAYLIST' });
      } else {
        _showAlert(updatePlaylist.error, 'error');
      }
    }
  }, [updatePlaylist, addPlaylistTagStatus, deletePlaylistTagStatus]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'CLEAR_STATE', actionName: 'UPDATE_PLAYLIST' });
    };
  }, []);

  // Add cleanup for DELETE_SONGS state
  useEffect(() => {
    return () => {
      dispatch({ type: 'DELETE_SONGS_RESET' });
      setIsDeleteInitiatedHere(false); // Clear flag on unmount
    };
  }, []);

  useEffect(() => {
    if (songURL.status === 200 && songURL.url) {
      window.open(songURL.url, '_blank');
      dispatch({ type: 'CLEAR_STATE', actionName: 'GET_SONG_URL' });
    }
    if (songURL?.error) {
      _showAlert(songURL?.error, 'error');
    }
  }, [songURL]);

  // Add useEffect to handle permanent delete response
  useEffect(() => {
    // Only handle delete response if it was initiated from this component
    if (isDeleteInitiatedHere && deleteSongs.status === 'success') {
      setLoading(false);
      _showAlert('Song permanently deleted from all playlists and server', 'success');

      setPlaylistSongs((current) => current.filter((song) => song.id !== selectedSong?.id));
      setPlaylist((current) => ({ ...current,
        songs: (current.songs || []).filter((song) => song.id !== selectedSong?.id) }));
      setSelectedSongIds((current) => current.filter((id) => id !== selectedSong?.id));

      // Simply refresh the playlist data - let the existing logic handle the update
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: '', tagIds: [] });
      dispatch({ type: 'DELETE_SONGS_RESET' });
      setIsDeleteInitiatedHere(false); // Reset the flag
    }
    if (isDeleteInitiatedHere && deleteSongs.status === 'failed') {
      setLoading(false);
      _showAlert(deleteSongs.result?.error || 'Failed to delete song', 'error');
      dispatch({ type: 'DELETE_SONGS_RESET' });
      setIsDeleteInitiatedHere(false); // Reset the flag
    }
  }, [deleteSongs.status, isDeleteInitiatedHere]);

  // const handlePlaySong = async (song, index) => {
  //   if (!audioRef.current) {
  //     // show error;
  //     return;
  //   }
  //   const prevSong = currentPlayingSong;
  //   setCurrentPlayingSong(song);

  //   if (prevSong?.id === song.id) {
  //     if (isSongPlaying) {
  //       audioRef.current.pause();
  //       setIsSongPlaying(false);
  //       return;
  //     }
  //     setIsSongLoading(true);
  //     audioRef.current.src = `${process.env.REACT_APP_API_URL}/songs/${song.id}.mp3`;
  //     audioRef.current.play().then(() => {
  //       setIsSongLoading(false);
  //       setIsSongPlaying(true);
  //     });
  //     return;
  //   }

  //   if (isSongPlaying) {
  //     audioRef.current.pause();
  //     setIsSongPlaying(false);
  //   }

  //   setIsSongLoading(true);
  //   audioRef.current.src = `${process.env.REACT_APP_API_URL}/songs/${song.id}.mp3`;
  //   audioRef.current.play().then(() => {
  //     setIsSongLoading(false);
  //     setIsSongPlaying(true);
  //   });
  // };

  const handleAddNewSongs = () => {
    if (isLoading || !selectedPlaylist.id || selectedPlaylist.id !== requestedPlaylistId) return;
    if (isPageOpenedAsPopup) {
      // When opening the Add Songs popup, remove the player from this popup
      setNavbarCurrentSong(null);
      setIsAddSongsPopupOpen(true);
    } else {
      props.history.push({
        pathname: isRoyalties ? '/royalties/edit-playlist-and-server' : '/non-royalties/edit-playlist-and-server',
        state: { selectedPlaylist: { ...selectedPlaylist, name, songs: playlistSongs,
          type: playlistTypeToSave,
          originalName: selectedPlaylist.name,
          originalType: selectedPlaylist.type,
          originalSongIds: selectedPlaylist.songs?.map((song) => song.id) } },
      });
    }
  };

  const handleUpdatePlaylist = () => {
    if (conflict) {
      setConflictOpen(true);
      return;
    }
    if (!selectedPlaylist.id || selectedPlaylist.id !== requestedPlaylistId || !Array.isArray(selectedPlaylist.songs) || isLoading) {
      _showAlert('Playlist is still loading. Please try again.', 'error');
      return;
    }
    setLoading(true);
    tagsSubmitted.current = false;
    dispatch({
      type: 'UPDATE_PLAYLIST',
      payload: buildPlaylistSavePayload({
        id: selectedPlaylist.id,
        originalSongIds: selectedPlaylist.songs.map((song) => song.id),
        songs: playlistSongs,
        originalName: selectedPlaylist.name,
        name,
        originalType: selectedPlaylist.type,
        type: playlistTypeToSave,
      }),
    });
  };

  const handleTagSelection = (tag) => {
    setSelectedTags((prevSelectedTags) =>
      prevSelectedTags.includes(tag) ? prevSelectedTags.filter((t) => t !== tag) : [...prevSelectedTags, tag]
    );
  };

  //* Tags excluding already added tags
  const filteredTags = tagList.tags?.filter(
    (tag) =>
      tag.name.toLowerCase().includes(searchInput.toLowerCase()) &&
      !selectedPlaylist.tags?.some((selectedTag) => selectedTag.name === tag.name)
  );

  const combinedTags = [...(selectedPlaylist.tags || []), ...(selectedTags || [])];

  const handleSortByDate = () => {
    let sortedItems = [...playlistSongs].sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(a.createdAt) - new Date(b.createdAt);
    });
    setPlaylistSongs([...sortedItems]);
  };

  const handleSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSortConfig({ key: newKey, direction });

    if (!newKey) {
      return;
    }


    const sortedItems = [...playlistSongs].sort((a, b) => {
      if (newKey === 'createdAt') {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return direction === 'asc' ? dateA - dateB : dateB - dateA;
      }

      if (newKey === 'name') {
        const nameA = a.name || a.fileName || '';
        const nameB = b.name || b.fileName || '';
        return direction === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      }

      if (newKey === 'artist') {
        const artistA = a.artist || '';
        const artistB = b.artist || '';
        return direction === 'asc' ? artistA.localeCompare(artistB) : artistB.localeCompare(artistA);
      }

      return 0;
    });

    setPlaylistSongs(sortedItems);
  };

  // Find current song index in the list for navbar player
  const getCurrentSongIndex = () => {
    if (!navbarCurrentSong || !Array.isArray(playlistSongs)) return -1;
    return playlistSongs.findIndex(song => song.id === navbarCurrentSong.id);
  };

  // Check if there's a next song
  const hasNextSong = () => {
    const currentIndex = getCurrentSongIndex();
    return currentIndex >= 0 && currentIndex < playlistSongs.length - 1;
  };

  // Check if there's a previous song
  const hasPrevSong = () => {
    const currentIndex = getCurrentSongIndex();
    return currentIndex > 0;
  };

  // Handle playing next song
  const handleNextSong = () => {
    const currentIndex = getCurrentSongIndex();
    if (currentIndex >= 0 && currentIndex < playlistSongs.length - 1) {
      const nextSong = playlistSongs[currentIndex + 1];
      setNavbarCurrentSong(nextSong);
    }
  };

  // Handle playing previous song
  const handlePrevSong = () => {
    const currentIndex = getCurrentSongIndex();
    if (currentIndex > 0) {
      const prevSong = playlistSongs[currentIndex - 1];
      setNavbarCurrentSong(prevSong);
    }
  };

  // Handle playing song from row (updates navbar player only)
  const handlePlaySongFromRow = (song) => {
    setNavbarCurrentSong(song);
  };

  // Handle closing the player
  const handleClosePlayer = () => {
    setNavbarCurrentSong(null);
  };

  const handleShuffle = () => {
    const shuffled = [...playlistSongs];
    var currentIndex = shuffled.length,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [shuffled[currentIndex], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[currentIndex]];
    }
    setPlaylistSongs(shuffled);
  };

  const handleRemoveSong = (song) => {
    setOpen(false);
    setPlaylistSongs((current) => current.filter((item) => item.id !== song.id));
    setSelectedSongIds((current) => current.filter((id) => id !== song.id));
  };

  const handleSelectSong = (songId, checked, shiftKey) => {
    const song = playlistSongs.find((item) => item.id === songId);
    if (!song) return;
    const selection = chooseRange('playlist-songs', playlistSongs, song, checked, shiftKey);
    setSelectedSongIds((current) => updateSelectedIds(current, selection));
  };

  const handleRemoveSelectedSongs = () => {
    const ids = new Set(selectedSongIds);
    setPlaylistSongs((current) => current.filter((song) => !ids.has(song.id)));
    setSelectedSongIds([]);
    resetRange('playlist-songs');
    setBulkRemoveOpen(false);
  };

  const handlePermanentRemoveSong = (song) => {
    setOpenPermanentDelete(false);

    // Prevent multiple delete requests
    if (deleteSongs.status === 'initiated') {
      return;
    }

    setLoading(true);
    setIsDeleteInitiatedHere(true); // Set flag before dispatching
    // Dispatch DELETE_SONGS action with single song ID
    dispatch({ type: 'DELETE_SONGS_RESET' });
    dispatch({ type: 'DELETE_SONGS', payload: { ids: [song.id] } });
  };

  const handleDeleteConfirmModal = (song) => {
    setOpen(true);
    setSelectedSong(song);
  };

  const handlePermanenConfirmModal = (song) => {
    setOpenPermanentDelete(true);
    setSelectedSong(song);
  };

  const handleUpdateImageClick = () => {
    setIsEditPopUpOpen(true);
    if (!selectedPlaylist.image) {
      // write logic here to fetch image
      setIsDraggableView(true);
    }
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
    } else if (e.type === 'dragleave') {
    }
  };

  const convertImageToUrl = (file) => {
    setImage(file);
    setImageUpaloadedFromPc(URL.createObjectURL(file));
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const type = e?.dataTransfer?.files?.[0]?.type;
      if (type === 'image/jpg' || type === 'image/png' || type === 'image/jpeg') {
        // handleFiles(e.dataTransfer.files);
        convertImageToUrl(e.dataTransfer.files[0]);
        setIsDraggableView(false);
      }
    }
  };

  const uploadImage = async () => {
    if (!image) {
      _showAlert('Please select image to upload', 'error');
      return;
    }
    try {
      setIsImageUploading(true);
      const formData = new FormData();
      formData.append('file', image);
      const playListId = props?.location?.state?.selectedPlayList?.id || selectedPlaylistForPopup?.id;
      const { tokens } = _isAuthenticated();
      const headers = {
        authorization: `${tokens?.accessToken}`,
      };
      await ApiCaller(`/v1/admin/playlists/${playListId}/image`, 'POST', formData, headers);
      setIsImageUploading(false);
      setIsEditPopUpOpen(false);
      _showAlert('Platlist image updated successfully', 'success');
    } catch (error) {
      _showAlert(error.message, 'error');
      setIsImageUploading(false);
      setIsEditPopUpOpen(false);
    }
  };

  return (
    <>
      {isEditPopUpOpen && (
        <div
          className="backDrop"
          onClick={() => {
            setIsEditPopUpOpen(false);
            setIsDraggableView(false);
          }}
        >
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <p className="headerText">Upload Image</p>
            <div className="contentContainer">
              {isDraggableView ? (
                <>
                  <form
                    id="form-file-upload"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}
                    onDragEnter={handleDrag}
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <div
                      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                      onDragEnter={handleDrag}
                      onDragLeave={handleDrag}
                      onDragOver={handleDrag}
                      onDrop={handleDrop}
                    >
                      <UploadImageSvg />
                      <p className="dragContent">Drag & Drop or Browse the files from your computer (only Jpeg and PNG)</p>
                    </div>
                    <RoundButton btnText="Select" className="modal_btn" handleClick={() => imageInputRef.current.click()} />
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      ref={imageInputRef}
                      onChange={(e) => {
                        convertImageToUrl(e.target.files[0]);
                        setIsDraggableView(false);
                      }}
                      accept="image/jpg, image/png, image/jpeg"
                    />
                  </form>
                </>
              ) : (
                <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column' }}>
                  <div className="imageContainer">
                    <LazyImage
                      style={{ height: '120px', width: '120px', objectFit: 'contain' }}
                      src={
                        imageUploadedFromPc ||
                        (selectedPlaylist.image &&
                          `${process.env.REACT_APP_MEDIA_URL}playlist_images/${selectedPlaylist.image}?${new Date().getTime()}`)
                      }
                      crossOrigin="anonymous"
                      alt="alt"
                    />
                  </div>
                  <div className="btnContainer">
                    {isImageUploading ? (
                      <CircularProgress />
                    ) : (
                      <>
                        <RoundButton className="modal_btn white_btn" btnText="Change" handleClick={() => setIsDraggableView(true)} />
                        <RoundButton className="modal_btn" btnText="Confirm" handleClick={uploadImage} />
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {isAddSongsPopupOpen && (
        <Popup open={isAddSongsPopupOpen} onClose={() => setIsAddSongsPopupOpen(false)} dialogClassName="edit-playlist-dialog-main">
          <EditPlaylistAndServer
            {...props}
            backdropClassName="edit-playlist-backdrop"
            isPageOpenedAsPopup={true}
            selectedPlaylistForPopup={{ ...selectedPlaylist, name, songs: playlistSongs,
              type: playlistTypeToSave,
              originalName: selectedPlaylist.name,
              originalType: selectedPlaylist.type,
              originalSongIds: selectedPlaylist.songs?.map((song) => song.id) }}
            onSavePlaylist={() => {
              setIsAddSongsPopupOpen(false);
              // Refresh the playlist data
              setPlaylistRefreshCount((count) => count + 1);
            }}
            isPlaylistRoyalty={isRoyalties}
          />
        </Popup>
      )}
      <PlaylistCustomerDialog
        playlist={selectedPlaylist}
        open={showCustomers}
        onClose={() => setShowCustomers(false)}
      />
      <PlaylistCopySongsDialog
        playlist={{ ...selectedPlaylist, songs: playlistSongs }}
        open={showCopySongs}
        onClose={() => setShowCopySongs(false)}
        initialSelectedIds={copySelectedOnly ? selectedSongIds : undefined}
      />
      <div className={`main edit-playlist-secondery ${isPageOpenedAsPopup ? 'edit-playlist-secondery-popup' : ''}`}>
        {isLoading && <LoaderSpinner />}
        {conflict && !conflictOpen && <div role="alert" className="playlist-management-error">
          This playlist changed elsewhere. <button type="button" onClick={() => setConflictOpen(true)}>Review both song lists</button>
        </div>}
        <PlaylistConflictDialog
          conflict={conflict ? { ...conflict, draft: playlistSongs } : null}
          open={conflictOpen}
          onClose={() => setConflictOpen(false)}
          onReload={reloadLatest}
          onAddAndReload={recovery.canAdd ? recovery.addAndReload : undefined}
          reloadOnly={recovery.reloadOnly}
          busy={recovery.busy}
          recoveryError={recovery.error}
          onRetry={() => refreshConflict(playlistSongs)}
        />
        {!isPageOpenedAsPopup && (
          <div className="sidebar">
            <Sidebar />
          </div>
        )}
        <AlertModal open={open} onClose={() => setOpen(false)} handelDelete={() => handleRemoveSong(selectedSong)} />
        <AlertModal
          open={bulkRemoveOpen}
          onClose={() => setBulkRemoveOpen(false)}
          handelDelete={handleRemoveSelectedSongs}
          description={`Remove ${selectedSongIds.length} selected songs from this playlist? Save to apply the change.`}
        />
        <AlertModal
          alertStyle="permanent_delete_style"
          heading="Permanent Delete"
          description="This action will remove the song from ALL playlists and delete it completely from the server. This cannot be undone."
          icon={<WarningIcon />}
          open={openPermanentDelete}
          onClose={() => setOpenPermanentDelete(false)}
          handelDelete={() => handlePermanentRemoveSong(selectedSong)}
        />
        <div className="leftPortion">
          <NavBar
            data="Edit Playlist"
            icon={Settings}
            currentRouteName="Playlist"
            breadcrumbsPath="Edit Playlist"
            text={isRoyalties ? 'Royalty' : 'Non-Royalty'}
            showPlayer={true}
            currentSong={navbarCurrentSong}
            onNextSong={handleNextSong}
            hasNextSong={hasNextSong()}
            onPrevSong={handlePrevSong}
            hasPrevSong={hasPrevSong()}
            onClosePlayer={handleClosePlayer}
          />
          <div className="content">
            <div className="tblUpperRow">
              <input
                className={!isFocusOnName && 'readonly-input'}
                onFocus={() => isNameEditable && setFocusOnName(true)}
                readOnly={!isNameEditable || !isFocusOnName}
                value={name}
                name="name"
                onChange={(event) => setName(event.target.value)}
                onBlur={() => setFocusOnName(false)}
              />
              <div className="grp_btn">
                {isStandardPlaylist && <Dropdown options={royalty} value={isRoyalty} setValue={setIsRoyalty} style={{ minWidth: '120px' }} />}
                {isAdmin && <RoundButton btnText="Update Image" handleClick={handleUpdateImageClick} />}
                <RoundButton btnText="Sort by date" handleClick={handleSortByDate} />
                <RoundButton
                  className={!isChangeOrder && 'disabled-button'}
                  btnText="Change order"
                  handleClick={() => setChangeOrder(!isChangeOrder)}
                />
                <RoundButton btnText="Shuffle" handleClick={handleShuffle} />
                <RoundButton btnText="Add Songs" handleClick={handleAddNewSongs} />
                <RoundButton btnText="Copy Songs" handleClick={() => { setCopySelectedOnly(false); setShowCopySongs(true); }} />
                <RoundButton
                  btnText={`Copy selected (${selectedSongIds.length})`}
                  disabled={!selectedSongIds.length}
                  handleClick={() => { setCopySelectedOnly(true); setShowCopySongs(true); }}
                />
                <RoundButton
                  btnText={`Remove selected (${selectedSongIds.length})`}
                  disabled={!selectedSongIds.length}
                  handleClick={() => setBulkRemoveOpen(true)}
                />
                {isAdmin && isStandardPlaylist && <RoundButton btnText="Customers" handleClick={() => setShowCustomers(true)} />}
                <RoundButton btnText="Save" handleClick={handleUpdatePlaylist} />
              </div>
            </div>

            <div className="tag_container">
              {combinedTags.map((tag, index) => (
                <div key={index} className="tag_item">
                  <div
                    className="color_circle tag_circle"
                    style={{
                      backgroundColor: tag.color || '#e7ddff',
                    }}
                  />
                  <label className="tag_name">{tag.name}</label>
                  <div
                    className="cross-icon"
                    onClick={() => {
                      if (selectedTags.includes(tag)) {
                        setSelectedTags((prevSelectedTags) => prevSelectedTags.filter((t) => t !== tag));
                      }
                      if (selectedPlaylist && selectedPlaylist.tags) {
                        const filteredTags = selectedPlaylist.tags.filter((t) => t.name !== tag.name);
                        setPlaylist({ ...selectedPlaylist, tags: filteredTags });
                        if (tag.tagId) {
                          setRemoveApiTagsIds((prev) => [...prev, tag.tagId]);
                        }
                      }
                    }}
                  />
                </div>
              ))}
              <div
                className="add_tag"
                onClick={() => {
                  setIsAddTagPopUpOpen(true);
                }}
              >
                <p className="tag_text">Add Tag</p>
                <img src={plusIcon} alt="plus icon" />
              </div>
            </div>

            <p className="playlist-selection-hint">Click a song checkbox, then Shift-click another to select or clear the range between them.</p>
            <TableContainer className="tbl_wraper table-height" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        checked={playlistSongs.length > 0 && playlistSongs.every((song) => selectedSongIds.includes(song.id))}
                        indeterminate={selectedSongIds.length > 0 && selectedSongIds.length < playlistSongs.length}
                        onChange={(event) => {
                          resetRange('playlist-songs');
                          setSelectedSongIds(event.target.checked ? playlistSongs.map((song) => song.id) : []);
                        }}
                        inputProps={{ 'aria-label': 'Select entire playlist' }}
                      />
                      <RangeSelectionButton active={isRangeMode('playlist-songs')} onClick={() => toggleRangeMode('playlist-songs')} />
                    </TableCell>
                    <TableCell className="table_font table-index-cell">Result</TableCell>
                    <TableCell
                      onClick={() => handleSort('createdAt')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Date<SortIndicator sortConfig={sortConfig} columnKey="createdAt" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('name')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Song Name<SortIndicator sortConfig={sortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('artist')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Artist<SortIndicator sortConfig={sortConfig} columnKey="artist" />
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                {Array.isArray(playlistSongs) && playlistSongs.length ? (
                  <SortableList
                    handleRemoveSong={handleDeleteConfirmModal}
                    isChangeOrder={isChangeOrder}
                    items={playlistSongs}
                    onSortEnd={onSortEnd}
                    pressDelay={200}
                    onPlaySong={handlePlaySongFromRow}
                    selectedSongIds={selectedSongIds}
                    onSelectSong={handleSelectSong}
                    shouldCancelStart={(event) => !!event.target.closest('input, button, .MuiCheckbox-root, img')}
                  />
                ) : null}
              </Table>
            </TableContainer>
          </div>
        </div>
        {isAddTagPopUpOpen && (
          <Popup open={isAddTagPopUpOpen} onClose={() => setIsAddTagPopUpOpen(false)}>
            <div
              className="create_playlist tag_popup"
              style={{
                width: '500px',
              }}
            >
              <p className="header">Tags</p>
              <div className="tag_search_row">
                <input
                  className="input_field"
                  placeholder="Search tags here..."
                  type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <img src={search} alt="search icon" />
              </div>

              <div
                className="tag_list"
                style={{
                  height: '180px',
                  overflowY: 'auto',
                }}
              >
                {filteredTags.map((tag) => (
                  <div key={tag.id} className="tag_item">
                    <input type="checkbox" checked={selectedTags.includes(tag)} onChange={() => handleTagSelection(tag)} />
                    <label>
                      {
                        // tag?.name upto 20 characters + '...'
                        tag?.name.length > 20 ? tag?.name.substring(0, 20) + '...' : tag?.name
                      }
                    </label>
                  </div>
                ))}
              </div>

              <RoundButton className="add-btn" btnText={'Add'} handleClick={() => setIsAddTagPopUpOpen(false)} />
            </div>
          </Popup>
        )}
      </div>
    </>
  );
}

export default EditPlaylistSecondery;
